define(["exports", "react", "styled-components", "framer-motion"], function (_exports, _react, _styledComponents, _framerMotion) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.DropdownCaret = DropdownCaret;
  _exports.DropdownHeaderCaretDownIcon = void 0;
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  var DropdownHeaderCaretDownIcon = (0, _styledComponents.default)(_framerMotion.motion.div).withConfig({
    displayName: "Carret__DropdownHeaderCaretDownIcon",
    componentId: "sc-12eefuj-0"
  })(["margin-top:4px;"]);
  _exports.DropdownHeaderCaretDownIcon = DropdownHeaderCaretDownIcon;
  var caret = {
    open: {
      rotateX: -180,
      color: '#F7902A',
      y: -2
    },
    closed: {
      rotateX: 0,
      color: '#373737',
      y: 0
    }
  };

  function DropdownCaret(_ref) {
    var isOpen = _ref.isOpen;
    return /*#__PURE__*/_react.default.createElement(DropdownHeaderCaretDownIcon, {
      animate: isOpen ? 'open' : 'closed',
      variants: caret
    }, /*#__PURE__*/_react.default.createElement("box-icon", {
      name: "down-arrow",
      type: "solid",
      size: "xs",
      color: "currentColor"
    }));
  }
});